import { action, observable } from "mobx";
import {
    BaseViewStore,
} from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import {FacilityService} from 'application/facility/services';
import _ from 'lodash';
import { BulkEmrModalForm } from 'application/facility/forms';

@applicationContext
class BulkEmrModalStore extends BaseViewStore {
    @observable accessor items = null;
    constructor(rootStore, componentProps) {
        const service = new FacilityService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'bulk-emr-modal',
            autoInit: true,
            routes:{}
        });

        this.service = service;
        this.modalData = componentProps.modalParams.data;
        this.modalParams = componentProps.modalParams;
        this.form = new BulkEmrModalForm({
            onSuccess: (form) => {
                const item = form.values();
                return this.updateResource(item);
            }
        });

        this.form.update(this.modalData);

        this.getResource();
    }

    @action.bound
    async getResource() {
        const response = await this.service.find({
            embed:"AccountRep,Corporate",
            emr: this.modalData.emr,
            emrUserName: this.modalData.emrUserName,
            inActive:false,
            rpp:500
        });
        
        _.extend(response.data,
        {
            item: _.map(response.data.item, (item => {
                return _.extend(
                    item, {       
                        corporate:  item.corporate_ ? item.corporate_.name : '',                 
                    }
                );
            }))                         
        });

        this.items = response.data.item;
    }

    @action.bound
    async updateResource(resource) {
        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            _.each(this.items, item=>{
                item.emr = resource.emr;
                //item.emrAccountName = resource.emrAccountName;
                item.emrUserName = resource.emrUserName;
                item.emrPassword = resource.emrPassword;
                item.accountRep = null;
                item.corporate_ = null;
            });

            await this.service.bulkUpdate(this.items);

            this.modalData.updateEmrFields(resource);
            this.form.setFieldsDisabled(false);
            this.modalParams.close();
            await setTimeout(() => this.notifySuccessUpdate(this.name), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error('EDIT_FORM_LAYOUT.ERROR_UPDATE', err);
        }
    }
    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success('EDIT_FORM_LAYOUT.SUCCESS_UPDATE', name);
    }
}

export default BulkEmrModalStore;
